// extracted by mini-css-extract-plugin
export default {"container":"CPMn","header":"Unaj","containerRegistrationForm":"RGTN","pageSubtitle":"iFr9"};